import {Component, Inject} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

// services
import {TasksService} from "../../../shared/services/tasks.service";
import {SnackbarService} from "../../../shared/services/snackbar.service";

// models
import {ApiMessage} from "../../../shared/models/api-message";
import {AuthService} from "../../../shared/services/auth.service";


@Component({
    selector: 'app-task-completed-modal',
    templateUrl: './task-completed-modal.component.html',
    styleUrl: './task-completed-modal.component.scss'
})
export class TaskCompletedModalComponent {

    public taskID = 0;
    public checked = false;
    public isSaved = false;

    constructor(private authService: AuthService,
                private tasksService: TasksService,
                private snackbarService: SnackbarService,
                private dialogRef: MatDialogRef<TaskCompletedModalComponent>,
                @Inject(MAT_DIALOG_DATA)
                data: {
                    taskID: number
                }) {
        this.taskID = data.taskID;
    }

    public completed(): void {
        this.isSaved = true;
        const userType = this.authService.user.type;
        const taskData = {
            completed: true,
            status: 'zakończone',
        };
        this.tasksService.updateTask(userType, this.taskID, taskData).subscribe({
            next: (res: ApiMessage): void => {
                this.snackbarService.snackbarCustomComplete(res.message);
            },
            error: (e) => this.snackbarService.snackbarCustomError(e.error.message),
            complete: () => {
                this.isSaved = false;
                this.dialogRef.close();
            }
        })
    }
}
